// The address as the page was opened, read before Supabase consumes the sign-in link in it.
// A password-reset email lands with "#…type=recovery…".
export const initialHash = typeof window === 'undefined' ? '' : window.location.hash;
export const openedForRecovery = /type=recovery/.test(initialHash);
